import { render, staticRenderFns } from "./FlagOptionLabel.vue?vue&type=template&id=4e2382af&scoped=true"
import script from "./FlagOptionLabel.vue?vue&type=script&lang=js"
export * from "./FlagOptionLabel.vue?vue&type=script&lang=js"
import style0 from "./FlagOptionLabel.vue?vue&type=style&index=0&id=4e2382af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2382af",
  null
  
)

export default component.exports